import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useAppConfig } from "@limitless/common/hooks";
import { useExpertProfile } from "./ExpertProfileHook";
// Set the default state values for each context
export const ExpertProfileContext = /*#__PURE__*/createContext({});
export const ExpertProfileContextProvider = ({
  children
}) => {
  const expertProfile = useExpertProfile();
  const {
    stateTracker
  } = useDevLogging();
  const appconfig = useAppConfig();
  const profileContext = useMemo(() => {
    stateTracker.trackState({
      profile: expertProfile.profile
    });
    return {
      ...expertProfile
    };
  }, [expertProfile.profile, expertProfile.isEditable, expertProfile.loading, appconfig.localeConfig, expertProfile.securityProfileChanged, expertProfile.hasProfileLoadFailed, expertProfile.isDarkMode, expertProfile.theme, expertProfile.profileTenantsBrandAsset]);
  return /*#__PURE__*/React.createElement(ExpertProfileContext.Provider, {
    value: profileContext
  }, children);
};
export const useExpertProfileContext = () => {
  return useContext(ExpertProfileContext);
};
ExpertProfileContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};